import { render, staticRenderFns } from "./ModalShow.vue?vue&type=template&id=4bf38f36"
import script from "./ModalShow.vue?vue&type=script&lang=js"
export * from "./ModalShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports